import localConfig from '@/config';
import { QueryKeys } from '@/constants/queryKeys';
import { contentfulClient } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { StreamersNextStreamDateSkeleton } from '../types';
import { isFuture } from 'date-fns';

const fetchStreamersNextStreamDate = async () => {
  try {
    let content = [];

    if (localConfig.showContentLive) {
      content = (
        await contentfulClient.getEntries<StreamersNextStreamDateSkeleton>({
          content_type: 'streamersNextStreamDate',
        })
      ).items;
    } else {
      content = (
        await axios.get<void, AxiosResponse<StreamersNextStreamDateSkeleton[]>>(
          `${localConfig.contentfulUrl}/streamersNextStreamDate.json`
        )
      ).data;
    }
    return content.length > 0 && isFuture(content.map((item) => item.fields.date)[0])
      ? content.map((item) => item.fields.date)[0]
      : null;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const useStreamersNextStreamDate = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.STREAMERS_NEXT_STREAM_DATE],
    queryFn: fetchStreamersNextStreamDate,
    refetchOnWindowFocus: localConfig.showContentLive,
    ...options,
  });
};
